{
  "todayButton": "Astăzi",
  "nextMonth": "Luna următoare",
  "previousMonth": "Luna anterioară",
  "nextYear": "Anul următor",
  "previousYear": "Anul anterior",
  "weekdays": [
    "Duminică",
    "Luni",
    "Marți",
    "Miercuri",
    "Joi",
    "Vineri",
    "Sâmbătă"
  ],
  "months": [
    "Ianuarie",
    "Februarie",
    "Martie",
    "Aprilie",
    "Mai",
    "Iunie",
    "Iulie",
    "August",
    "Septembrie",
    "Octombrie",
    "Noiembrie",
    "Decembrie"
  ]
}
